import { ErrorMessageAction, ErrorMessageState } from 'store/data/errorMessage';
import { domainUtility } from 'utility';

const initialState: ErrorMessageState = { allIds: [], byId: {} };

const errorMessageReducer = (
  state: ErrorMessageState = initialState,
  action: ErrorMessageAction,
): ErrorMessageState => {
  switch (action.type) {
    case 'data/errorMessage/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/errorMessage/SET':
      return domainUtility.set(state, action.payload);
    case 'data/errorMessage/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/errorMessage/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/errorMessage/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default errorMessageReducer;
